import {
  PerspectiveGroupingRule,
  PerspectivesGroupsOptions,
  addNewGroupingRule,
  deleteGroupingRule as deleteGroupingRule_,
  updateGroupingRules,
} from '@ardoq/perspectives';
import { UpdateGroupingRulePayload } from 'perspective/perspectiveEditor/perspectivesEditor$';
import { getGroupsTabInitialState } from 'perspective/perspectiveEditor/perspectivesEditor$/groupings/groupsTabReducers';
import { GroupingRulesState } from './groupingRulesTypes';
import { SetGroupingRulesPayload } from './viewpointGroupingRulesActions';
import { ViewIds } from '@ardoq/api-types';
import { SelectedViewState } from '../selectedView/types';

const clearGroupingTabState = (
  state: GroupingRulesState
): GroupingRulesState => ({
  ...state,
  groupingRules: [],
});

const createGroupingRule = (
  state: GroupingRulesState,
  newGroupingRule: PerspectiveGroupingRule
) => ({
  ...state,
  groupingRules: addNewGroupingRule(state.groupingRules, newGroupingRule, true),
});

const updateGroupingRule = (
  state: GroupingRulesState,
  { updatedGroupingRuleId, updatedGroupingRule }: UpdateGroupingRulePayload
) => ({
  ...state,
  groupingRules: updateGroupingRules(
    state.groupingRules,
    updatedGroupingRuleId,
    updatedGroupingRule
  ),
});

const reorderGroupingRules = (
  state: GroupingRulesState,
  reorderedGroupingRules: PerspectiveGroupingRule[]
) => ({
  ...state,
  groupingRules: reorderedGroupingRules,
});

const deleteGroupingRule = (
  state: GroupingRulesState,
  deletedGroupingRuleId: string
) => ({
  ...state,
  groupingRules: deleteGroupingRule_(
    state.groupingRules,
    deletedGroupingRuleId
  ),
});

const getInitialState = (): GroupingRulesState => ({
  ...getGroupsTabInitialState(),
  viewName: ViewIds.NONE,
  groupingOptions: {
    appliedGroupingRules: [],
    workspaces: [],
    referenceTypesPerWorkspace: {},
    componentTypesPerWorkspace: {},
    fieldsPerWorkspace: {},
    tagsPerWorkspace: {},
    globalComponentTypeNames: [],
    globalReferenceTypeNames: [],
  },
});

const setGroupingOptions = (
  state: GroupingRulesState,
  groupingOptions: PerspectivesGroupsOptions
) => ({
  ...state,
  groupingOptions,
});

const setGroupingRules = (
  state: GroupingRulesState,
  { groupingRules }: SetGroupingRulesPayload
) => ({
  ...state,
  groupingRules,
});

const getGroupingRulesCount = (state: GroupingRulesState): number => {
  return state.groupingRules.length;
};

const setViewName = (
  state: GroupingRulesState,
  { selectedView }: SelectedViewState
) => ({
  ...state,
  viewName: selectedView?.value || ViewIds.NONE,
});

export const viewpointGroupingRulesOperations = {
  clearGroupingTabState,
  createGroupingRule,
  updateGroupingRule,
  reorderGroupingRules,
  deleteGroupingRule,
  getInitialState,
  setGroupingOptions,
  setGroupingRules,
  getGroupingRulesCount,
  setViewName,
};
